// Sticky Nav

// when sticky-nav-wrap is at the top of the screen, change its position to fixed
document.addEventListener("DOMContentLoaded", function () {

    const stickyNavWrap = document.getElementById('sticky-nav-wrap');
    const stickyNav = document.getElementById('sticky-nav');

    function adjustStickyNavPosition() {

        if (!stickyNavWrap || !stickyNav) return;
        const stickyNavWrapTop = stickyNavWrap.getBoundingClientRect().top;

        if (stickyNavWrapTop <= 0) {
            stickyNav.classList.add('sticky-nav-fixed');
        } else {
            stickyNav.classList.remove('sticky-nav-fixed');
        }
    }
    window.addEventListener('scroll', adjustStickyNavPosition);
    adjustStickyNavPosition();
});


Site.StickyNav = {
    elems: {
        navWrap: document.getElementById("sticky-nav-wrap"),
        nav: document.getElementById("sticky-nav")
    }, init() {
        //const e = Site.StickyNav.elems.navWrap.querySelectorAll(".sticky-nav-section");
        if (Site.elems.navWrap) {
            const e = Site.elems.navWrap.querySelectorAll(".sticky-nav-section");
            window.addEventListener("scroll", () => {
                e.forEach(e => {
                    const t = e.getAttribute("id"), i = e.getBoundingClientRect();
                    i.y <= 1 && i.y + i.height > 1 && (Site.StickyNav.elems.nav.querySelectorAll(".scroll-link.active").forEach(e => {
                        e.classList.remove("active")
                    }), Site.StickyNav.elems.nav.querySelector('.scroll-link[data-id="' + t + '"]').classList.add("active"))
                })
            }, {passive: !0})
        }

    }
}, Site.StickyNav.init();




